// Generic collapse toggle function using data attributes
class FAQAccordion {
  constructor() {
    this.init();
  }
  init() {
    // Hide all targets by default
    document.querySelectorAll('[data-target]').forEach(el => {
      const targetSelector = el.getAttribute('data-target');
      if (targetSelector) {
        const target = document.querySelector(targetSelector);
        if (target) target.classList.add('hidden');
      }
    });
    // Attach click event to all accordions
    document.querySelectorAll('[data-accordion]').forEach(btn => {
      btn.addEventListener('click', function() {
        const targetSelector = btn.getAttribute('data-target');
        if (!targetSelector) return;
        const target = document.querySelector(targetSelector);
        if (target) {
          btn.classList.toggle('open');
          target.classList.toggle('hidden');
        }
      });
    });
  }
}

class FAQSearch {
  constructor() {
    this.searchInput = document.querySelector('.faq-search-input');
    this.groupWrappers = document.querySelectorAll('.faq-group-wrapper');
    this.nothingFoundMsg = document.querySelector('.faq-nothing-found');
    this.filterButtons = document.querySelectorAll('[data-filter]');
    this.activeFilter = 'all';
    this.init();
  }
  init() {
    if (!this.searchInput) return;
    this.searchInput.addEventListener('input', () => this.handleSearch());
    this.filterButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update active button styles
        this.filterButtons.forEach(b => b.classList.remove('btn-primary'));
        this.filterButtons.forEach(b => b.classList.add('btn-outline-primary'));
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-primary');
        // Set filter and update
        this.activeFilter = btn.getAttribute('data-filter');
        this.handleSearch(); // re-run search on filter change
      });
    });
  }
  handleSearch() {
    const query = this.searchInput.value.trim().toLowerCase();
    let anyVisible = false;
    this.groupWrappers.forEach(group => {
      const groupId = group.getAttribute('data-group');
      // Only search in visible groups (all, or matching filter)
      const groupShouldBeVisible = (this.activeFilter === 'all' || groupId === this.activeFilter);
      let groupHasVisible = false;
      const questionWrappers = group.querySelectorAll('.faq-question-wrapper');
      questionWrappers.forEach(q => {
        const title = q.querySelector('.faq-question-title')?.textContent.toLowerCase() || '';
        const answer = q.querySelector('.faq-answer-content')?.textContent.toLowerCase() || '';
        const matches = (title.includes(query) || answer.includes(query));
        if (groupShouldBeVisible && matches) {
          q.style.display = '';
          groupHasVisible = true;
        } else {
          q.style.display = 'none';
        }
      });
      // Show/hide group based on filter and search
      if (groupShouldBeVisible && groupHasVisible) {
        group.style.display = '';
        anyVisible = true;
      } else {
        group.style.display = 'none';
      }
    });
    if (this.nothingFoundMsg) {
      this.nothingFoundMsg.style.display = anyVisible ? 'none' : '';
    }
  }
}

// Initialize both classes on DOMContentLoaded
window.addEventListener('DOMContentLoaded', () => {
  new FAQAccordion();
  new FAQSearch();
});


